<template>
    <page :tabs="tabs" :busy="busy">
        <grid ref="grid" :columnDefs="columnDefs" :rowData="items">
            <responsive-button
                @click="exportToExcel"
                :icon="['fas', 'file-excel']"
                variant="primary"
            >
            </responsive-button>
            <responsive-button
                @click="fetchData"
                :icon="['fas', 'arrows-rotate']"
                title="Refresh"
                variant="primary"
            >
                Refresh
            </responsive-button>
        </grid>
    </page>
</template>

<script>
import Grid from '../../generic/grid/grid.vue';
import page from '../../generic/page/page.vue';
import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
import {
    GEOGRAPHIC_LISTING_LIST_ENDPOINT,
    GEOGRAPHIC_LISTING_EXCEL_ENDPOINT,
} from '../../../endpoints';
import API from '../../../api';
export default {
    components: { page, Grid, ResponsiveButton },
    data() {
        return {
            tabs: [
                {
                    title: 'Geographic Listing',
                    active: true,
                },
            ],
            busy: null,
            offset: 0,
            limit: 20,
            sort: 'address.country_name',
            desc: false,
            search: '',
            items: [],
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                this.busy = true;
                const response = await API.get(
                    GEOGRAPHIC_LISTING_LIST_ENDPOINT()
                );
                this.items = response.data.map((item) => ({
                    ...item,
                    id: (Math.random() * 1e128).toString(12),
                }));
            } catch (e) {
                this.errorToast({ text: 'Could not load data' });
            } finally {
                this.busy = false;
            }
        },
        exportToExcel() {
            this.generatingExcelReportSuccessToast();
            const columns = this.$refs.grid.gridOptions.columnApi.getColumns();
            const sortedColumn = columns.find((item) => item.sort);
            const link = `${GEOGRAPHIC_LISTING_EXCEL_ENDPOINT()}?desc=${
                sortedColumn.sort !== 'asc'
            }&offset=${this.offset}&limit=${this.limit}&sort=${
                sortedColumn.colId
            }&search=${this.$refs.grid.search ? this.$refs.grid.search : ''}`;
            window.location.href = link;
        },
    },
    computed: {
        columnDefs() {
            return [
                {
                    field: 'address.country_name',
                    headerName: 'Country',
                    sort: 'asc',
                    minWidth: 300,
                },
                {
                    field: 'address.state_name',
                    headerName: 'State/Region',
                    minWidth: 200,
                },
                {
                    field: 'address.city',
                    headerName: 'City',
                    minWidth: 150,
                },
                {
                    field: 'number_of_listings',
                    headerName: 'Number of listings',
                    minWidth: 100,
                },
            ];
        },
    },
};
</script>